// export function signInRequest(login, senha) {
//   return {
//     type: '@auth/SIGN_IN_REQUEST',
//     payload: { login, senha },
//   }
// }

export function signInSuccess(token, usuario) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, usuario },
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}
